export default "__VITE_ASSET__CSgwyeIb__"